import React from 'react';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import SearchBar from '../../SearchBar';
import Header from '../../Header';
import AnimatedBanner from '../../AnimatedBanner';
import Heading from '../Heading';

const StyledContent = styled(Container)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 645px;
  padding-bottom: 80px;
  padding-left: 20px;
  padding-right: 20px;
  .Landing__Top__Search {
    min-height: 132px;
  }
  @media (max-width: 1024px) {
    min-height: 400px;
  }

  @media (max-width: 767px) {
    min-height: 0;
    padding: 30px 16px 10px;
    .Landing__Top__Search {
      min-height: 70px;
    }
  }
`;

const StyledSubHeading = styled(Container)`
  font-size: 22px;
  font-weight: 600;
  line-height: 1.3em;
  color: #ffffff;
  margin-top: 8px;
  @media (max-width: 767px) {
    margin-right: auto;
  }
`;

const Top = ({
  heading,
  subHeading,
  defaultCategoryValue,
  bannerImage,
  headerTransparent,
  searchShow = true,
  children,
  searchProps = {},
}) => {
  return (
    <AnimatedBanner bannerImage={bannerImage}>
      <Header
        defaultCategoryValue={defaultCategoryValue}
        slideIn
        showIconSearch
        headerTransparent={headerTransparent}
      />
      <StyledContent className="Landing__Top__bannerContent">
        <Heading>{heading}</Heading>
        {subHeading && (
          <StyledSubHeading className="Landing__Top__subHeading">
            {subHeading}
          </StyledSubHeading>
        )}
        {searchShow && (
          <Container
            position="relative"
            zIndex={1000}
            display="flex"
            justifyContent="center"
            width="100%"
          >
            <Container width="100%" maxWidth="50rem" margin="25px 0">
              <SearchBar id="topSearch" type="page" {...searchProps} />
            </Container>
          </Container>
        )}
      </StyledContent>
      {children}
    </AnimatedBanner>
  );
};

export default Top;
